import { useContext } from 'react';

import { ApiContext } from './api.context';
import type { ApiEndpoints } from './api.endpoints';

export function useApi(): ApiEndpoints {
    const apiCtx = useContext(ApiContext);

    if (!apiCtx.api) {
        throw new Error('No API provided');
    }

    return apiCtx.api;
}
